import { Theme, fade } from '@material-ui/core/styles';

export const buildOverrides = (theme: Theme): any => ({
  MuiCssBaseline: {
    '@global': {
      '*': { boxSizing: 'border-box' },
      a: { textDecoration: 'none' },
      '.border-none': { border: '0px', '& td': { border: '0px' } },
      '.btn-xs': {
        minWidth: '30px !important',
        width: '30px',
        height: '30px',
        borderRadius: '6px !important',
        padding: '0px !important'
      },
      '.hover-text-primary:hover .text-hover': { color: theme.palette.primary.main },
      '.MuiCardHeader-action': { alignSelf: 'center !important' },
      '.MuiAlert-root .MuiAlert-icon': { color: 'inherit!important' },
      '.MuiButton-textSuccess:hover': {
        backgroundColor: theme.palette.success.main,
        color: '#fff'
      },
      '.MuiButton-textError:hover': { backgroundColor: theme.palette.error.main, color: '#fff' },
      '.MuiButton-textInfo:hover': { backgroundColor: theme.palette.info.main, color: '#fff' },
      '.MuiButton-textWarning:hover': {
        backgroundColor: theme.palette.warning.main,
        color: '#fff'
      },
      '.MuiButton-outlinedSuccess:hover': {
        backgroundColor: theme.palette.success.main,
        color: '#fff'
      },
      '.MuiButton-outlinedError:hover': {
        backgroundColor: theme.palette.error.main,
        color: '#fff'
      },
      '.MuiButton-outlinedInfo:hover': { backgroundColor: theme.palette.info.main, color: '#fff' },
      '.MuiButton-outlinedWarning:hover': {
        backgroundColor: theme.palette.warning.main,
        color: '#fff'
      }
    }
  },
  MuiButtonGroup: { root: { boxShadow: 'none' } },
  MuiAccordion: { root: { '&:before': { backgroundColor: theme.palette.grey[100] } } },
  MuiPaper: { root: { backgroundImage: 'none' } },
  MuiStepConnector: { line: { borderColor: theme.palette.divider } },
  MuiStepIcon: {
    root: {
      // unselected steps use the same grey as the multi-select chip
      color: theme.palette.chip.fill,
      '&:not(.MuiStepIcon-active):not(.MuiStepIcon-completed) .MuiStepIcon-text': {
        fill: theme.palette.grey[500]
      }
    },
    text: { fill: '#fff' },
    active: { color: theme.palette.secondary.main },
    completed: { color: theme.palette.secondary.main }
  },
  MuiFab: { root: { boxShadow: 'none' }, sizeSmall: { width: 30, height: 30, minHeight: 30 } },
  MuiButton: {
    root: { textTransform: 'none', boxShadow: 'none' },
    text: { padding: '5px 15px', backgroundColor: 'transparent' },
    outlined: {
      '&:hover': {
        borderColor: theme.palette.grey[400],
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.secondary
      }
    },
    textPrimary: { '&:hover': { backgroundColor: theme.palette.primary.main, color: 'white' } },
    textSecondary: { '&:hover': { backgroundColor: theme.palette.secondary.main, color: 'white' } },
    outlinedPrimary: { '&:hover': { backgroundColor: theme.palette.primary.main, color: 'white' } },
    outlinedSecondary: {
      '&:hover': { backgroundColor: theme.palette.secondary.main, color: 'white' }
    }
  },
  MuiCardHeader: { root: { padding: '16px 24px' }, title: { fontSize: '1.125rem' } },
  MuiCardContent: { root: { padding: 24 } },
  MuiTableCell: { root: { borderBottom: `1px solid ${theme.palette.divider}` } },
  MuiTableRow: { root: { '&:last-child td': { borderBottom: 0 } } },
  MuiLinearProgress: { root: { backgroundColor: theme.palette.grey[200], borderRadius: 6 } },
  MuiDivider: { root: { borderColor: theme.palette.divider } },
  MuiChip: {
    root: { fontWeight: 600, fontSize: '0.75rem' },
    outlined: {
      border: 'none',
      backgroundColor: theme.palette.chip.fill,
      '& .MuiChip-deleteIconOutlined': { color: 'rgba(0, 0, 0, 0.26)' },
      '&:hover .MuiChip-deleteIconOutlined': { color: 'rgba(0, 0, 0, 0.4)' }
    }
  },
  MuiAlert: {
    filledSuccess: { color: 'white' },
    filledInfo: { color: 'white' },
    filledError: { color: 'white' },
    filledWarning: { color: 'white' },
    standardSuccess: {
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.main
    },
    standardError: { backgroundColor: theme.palette.error.light, color: theme.palette.error.main },
    standardWarning: {
      backgroundColor: theme.palette.warning.light,
      color: theme.palette.warning.main
    },
    standardInfo: { backgroundColor: theme.palette.info.light, color: theme.palette.info.main },
    outlinedSuccess: {
      borderColor: theme.palette.success.main,
      color: theme.palette.success.main
    },
    outlinedWarning: {
      borderColor: theme.palette.warning.main,
      color: theme.palette.warning.main
    },
    outlinedError: { borderColor: theme.palette.error.main, color: theme.palette.error.main },
    outlinedInfo: { borderColor: theme.palette.info.main, color: theme.palette.info.main }
  },
  MuiOutlinedInput: {
    root: {
      background: '#FFFFFF',
      '& fieldset': { borderColor: theme.palette.grey[300] },
      '&:hover:not(:focus-within) fieldset': {
        borderColor: `${theme.palette.grey[300]} !important`
      },
      '&:focus-within fieldset': {
        borderColor: `${theme.palette.primary.main} !important`,
        borderWidth: 2
      },
      '&.Mui-disabled': {
        '& fieldset': { borderColor: `${theme.palette.action.disabled} !important` },
        '& input, & textarea, & .MuiSelect-root': {
          color: theme.palette.text.disabled,
          WebkitTextFillColor: theme.palette.text.disabled
        }
      }
    },
    input: {
      padding: '12px 14px',
      height: '1.4375em',
      fontFamily: 'Montserrat',
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: '-0.28px',
      color: theme.palette.text.primary
    },
    inputMultiline: { height: 'auto' },
    inputMarginDense: { padding: '8px 14px' }
  },
  MuiTooltip: {
    tooltip: {
      color: theme.palette.background.paper,
      background: theme.palette.text.primary
    }
  },
  MuiDrawer: { paper: { borderColor: theme.palette.divider } },
  MuiDialogTitle: { root: { fontSize: '1.25rem' } },
  MuiPopover: {
    paper: {
      border: `1px solid ${theme.palette.grey[300]}`,
      boxShadow: `0px 8px 24px ${fade(theme.palette.text.primary, 0.16)}`
    }
  },
  MuiAutocomplete: {
    root: {
      // nudge resting label to vertical center of the 44.15px box (matches CA2)
      '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': { top: 3 }
    },
    inputRoot: {
      '&[class*="MuiOutlinedInput-root"]': {
        minHeight: '44.15px',
        boxSizing: 'border-box',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '0 39px 0 14px'
      },
      '&[class*="MuiOutlinedInput-root"] [class*="MuiAutocomplete-input"]': { padding: '12px 0' }
    },
    paper: {
      border: `1px solid ${theme.palette.grey[300]}`,
      boxShadow: `0px 8px 24px ${fade(theme.palette.text.primary, 0.16)}`
    },
    tag: {
      backgroundColor: theme.palette.chip.fill,
      border: 'none',
      '& .MuiChip-deleteIcon': { color: 'rgba(0, 0, 0, 0.26)' },
      '&:hover .MuiChip-deleteIcon': { color: 'rgba(0, 0, 0, 0.4)' }
    }
  },
  MuiLink: { root: { cursor: 'pointer' } },
  MuiTab: { root: { textTransform: 'none' } },
  MuiSelect: {
    outlined: {
      minHeight: '44.15px !important',
      boxSizing: 'border-box !important',
      display: 'flex',
      alignItems: 'center',
      paddingRight: '32px'
    }
  },
  MuiInputLabel: {
    outlined: {
      transform: 'translate(14px, 14px) scale(1)',
      '&.MuiInputLabel-shrink': { transform: 'translate(14px, -6px) scale(0.75) !important' }
    }
  },
  MuiCheckbox: {
    root: {
      color: theme.palette.grey[400],
      '&:hover': { backgroundColor: fade(theme.palette.primary.main, 0.08) }
    },
    colorPrimary: {
      '&.Mui-checked': { color: theme.palette.primary.main },
      '&.Mui-checked:hover': { backgroundColor: fade(theme.palette.primary.main, 0.08) }
    }
  },
  MuiRadio: {
    root: {
      color: theme.palette.grey[400],
      '&:hover': { backgroundColor: fade(theme.palette.primary.main, 0.08) }
    },
    colorPrimary: { '&.Mui-checked': { color: theme.palette.primary.main } },
    colorSecondary: { '&.Mui-checked': { color: theme.palette.secondary.main } }
  },
  MuiSwitch: {
    root: { width: 42, height: 24, padding: 0, margin: '0 8px' },
    switchBase: {
      padding: 3,
      color: '#fff',
      '&.Mui-checked': { transform: 'translateX(18px)', color: '#fff' },
      '&.Mui-disabled': {
        cursor: 'not-allowed',
        color: '#fff',
        '& .MuiSwitch-thumb': { backgroundColor: '#fff' },
        '& + .MuiSwitch-track': {
          backgroundColor: `${theme.palette.grey[200]} !important`,
          opacity: '1 !important'
        },
        '&.Mui-checked + .MuiSwitch-track': {
          backgroundColor: `${theme.palette.secondary.main} !important`,
          opacity: '0.5 !important'
        }
      }
    },
    colorPrimary: {
      '&.Mui-checked': {
        color: '#fff',
        '& + .MuiSwitch-track': { backgroundColor: theme.palette.secondary.main, opacity: 1 }
      }
    },
    colorSecondary: {
      '&.Mui-checked': {
        color: '#fff',
        '& + .MuiSwitch-track': { backgroundColor: theme.palette.secondary.main, opacity: 1 }
      }
    },
    thumb: {
      width: 18,
      height: 18,
      borderRadius: 12,
      boxShadow:
        '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)'
    },
    track: {
      width: '100%',
      height: '100%',
      borderRadius: 12,
      backgroundColor: theme.palette.grey[200],
      opacity: 1
    }
  },
  MuiAppBar: {
    colorSecondary: { backgroundColor: theme.palette.primary.main, color: '#fff' }
  },
  MuiTabs: {
    indicator: { backgroundColor: 'var(--primary)', height: 4 }
  },
  MUIDataTableFilterList: {
    chip: {
      backgroundColor: '#EFF9F8',
      color: '#2E9A91',
      border: '1px solid #CDE9E6',
      borderRadius: 20,
      fontWeight: 600,
      fontSize: 13,
      '& .MuiChip-deleteIcon': { color: '#2E9A91' }
    }
  }
});

export const componentProps: any = {
  MuiButton: { disableElevation: true },
  MuiTextField: { variant: 'outlined' },
  MuiCheckbox: { disableRipple: true, color: 'primary' },
  MuiRadio: { disableRipple: true, color: 'primary' },
  MuiSwitch: { disableRipple: true }
};
